import React, { useState, useRef, useEffect } from "react";
import SvgIcon from "./svg-icon";
import chevronDownIcon from "../../images/chevron-down.svg";
import chevronUpIcon from "../../images/chevron-up.svg";

function ProductAccordion({ title, children }) {
  const [isOpen, setIsOpen] = useState(true);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.style.maxHeight = isOpen
        ? `${contentRef.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen]);

  return (
    <div className="product-accordion">
      <button
        className="header-accordion"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        {title}
        {isOpen ? (
          <SvgIcon
            src={chevronUpIcon}
            color="var(--theme-text-primary)"
            size={30}
          />
        ) : (
          <SvgIcon
            src={chevronDownIcon}
            color="var(--theme-text-primary)"
            size={30}
          />
        )}
      </button>
      <div ref={contentRef} className="content">
        {children}
      </div>
    </div>
  );
}

export default ProductAccordion;
